import { formatPlanDateRange } from '../../../../../../utils/utils'
import { PlansPlanMode } from '../../api/types'

type PlansListEmptyStatePlanMode =
  | PlansPlanMode.REBALANCE
  | PlansPlanMode.ALLOCATION
  | PlansPlanMode.IDEAL_PORTFOLIO

type PlansListEmptyStateProps = {
  planMode: PlansListEmptyStatePlanMode
  planSnapshotDate?: number | null
  planDurationInMonths?: number | null
}

const PLANS_LIST_EMPTY_STATE_CONFIG: Record<
  PlansListEmptyStatePlanMode,
  { illustrationSrc?: string; periodLabelClassName: string }
> = {
  [PlansPlanMode.REBALANCE]: {
    illustrationSrc: '/images/allocation/plans-empty-state-rebalance.png',
    periodLabelClassName: 'text-[13px] font-[400] text-[#cc5c2d]'
  },
  [PlansPlanMode.ALLOCATION]: {
    illustrationSrc: '/images/allocation/plans-empty-state-allocation.png',
    periodLabelClassName: 'text-[13px] font-[400] text-[#7048AC]'
  },
  [PlansPlanMode.IDEAL_PORTFOLIO]: {
    periodLabelClassName: 'text-[13px] font-[400] text-[#2e8ae5]'
  }
}

export function PlansListEmptyState({
  planMode,
  planSnapshotDate,
  planDurationInMonths
}: PlansListEmptyStateProps) {
  const emptyStateConfig = PLANS_LIST_EMPTY_STATE_CONFIG[planMode]
  const planMonthRangeLabel = planSnapshotDate
    ? formatPlanDateRange(planSnapshotDate, planDurationInMonths ?? 1).replace(/ plan$/, '')
    : ''

  return (
    <div className="bg-white px-5 pt-8 pb-12 h-[600px] flex items-center">
      <div className="flex flex-col gap-7 max-w-[279px]">
        <div className="flex">
          <PlansListEmptyStateIllustration illustrationSrc={emptyStateConfig.illustrationSrc} />
        </div>

        <div className="flex flex-col gap-5">
          {planMonthRangeLabel.length > 0 ? (
            <div className={emptyStateConfig.periodLabelClassName}>{planMonthRangeLabel}</div>
          ) : null}

          <div className="flex flex-col gap-5">
            <div className="text-[22px] font-[500] leading-[130%] text-[#232323]">
              All your rated funds are already in great shape
            </div>
            <div className="max-w-[259px] text-[13px] font-[400] leading-[140%] text-[#6A6E6E]">
              No changes are needed this month. We&apos;ll review it again next month to make sure it
              stays that way.
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export function PlansListEmptyStateIllustration({ illustrationSrc }: { illustrationSrc?: string }) {
  if (illustrationSrc) {
    return (
      <img src={illustrationSrc} alt="" className="h-[172px] w-[221px] object-contain" />
    )
  }

  return (
    <div
      className="h-[172px] w-[221px] rounded-xl border border-dashed border-[#C5CDD4] bg-[#E8EEF2]"
      aria-hidden
    />
  )
}
